var map = {
	"./Stroke 1.png": 1870,
	"./Why Our Save the Dat.png": 1871,
	"./all_about_shipping@2x.png": 1872,
	"./ask_for_everything@2x.png": 1873,
	"./big-day@1x.png": 1874,
	"./big-day@2x.png": 1875,
	"./birds@1x.png": 1876,
	"./birds@2x.png": 1877,
	"./check-list@1x.png": 1878,
	"./check-list@2x.png": 1879,
	"./circle-better@1x.png": 1880,
	"./circle-better@2x.png": 1881,
	"./empty_rsvp.png": 1882,
	"./empty_rsvp2x.png": 1883,
	"./envelope.png": 819,
	"./envelope.svg": 1884,
	"./envelope@2x.png": 1885,
	"./events_doodle.png": 698,
	"./events_doodle.svg": 1886,
	"./gifts@1x.png": 1887,
	"./gifts@2x.png": 1888,
	"./guest-list@1x.png": 1889,
	"./guest-list@2x.png": 1890,
	"./guest.png": 1891,
	"./guest.svg": 1892,
	"./guest2x.png": 1893,
	"./guest_approved@2x.png": 1894,
	"./invitations@1x.png": 1895,
	"./invitations@2x.png": 1896,
	"./invites_paper.svg": 1897,
	"./invites_paper@1x.png": 1898,
	"./invites_paper@2x.png": 1899,
	"./laptop-one-heart.png": 1900,
	"./laptop-one-heart@2x.png": 1901,
	"./laptop@1x.png": 1902,
	"./laptop@2x.png": 1903,
	"./long-page-checklist.png": 1904,
	"./long-page-checklist@2x.png": 1905,
	"./make_it_personal@2x.png": 1906,
	"./namecard-with-name.png": 1907,
	"./namecard-with-name@2x.png": 1908,
	"./namecard_no_name.svg": 699,
	"./namecard_with_name.svg": 1909,
	"./namecard_with_question_marks.svg": 386,
	"./no_address.png": 1910,
	"./no_address2x.png": 1911,
	"./onboarding_1.png": 1912,
	"./onboarding_1@2x.png": 1913,
	"./onboarding_2.png": 1914,
	"./onboarding_2@2x.png": 1915,
	"./onboarding_3.png": 1916,
	"./onboarding_3@2x.png": 1917,
	"./onboarding_4.png": 1918,
	"./onboarding_4@2x.png": 1919,
	"./red-star-left@1x.png": 1920,
	"./red-star-left@2x.png": 1921,
	"./red-star-right@1x.png": 1922,
	"./red-star-right@2x.png": 1923,
	"./registry_publish_champagne.svg": 1924,
	"./rsvp@1x.png": 1925,
	"./rsvp@2x.png": 1926,
	"./save-the-date@1x.png": 1927,
	"./save-the-date@2x.png": 1928,
	"./sparkle-left.svg": 766,
	"./sparkle-right.svg": 767,
	"./sparkle-up.svg": 826,
	"./ta-da.png": 1929,
	"./ta-da@2x.png": 1930,
	"./talk.svg": 1931,
	"./talk@1x.png": 769,
	"./talk@2x.png": 770,
	"./timeline-line-dark@1x.png": 1932,
	"./timeline-line-dark@2x.png": 1933,
	"./timeline-line@1x.png": 1934,
	"./timeline-line@2x.png": 1935,
	"./tips.svg": 771,
	"./underline_long@1x.png": 1936,
	"./underline_long@2x.png": 1937,
	"./underline_sm@1x.png": 1938,
	"./underline_sm@2x.png": 1939,
	"./website_publish_confetti.svg": 700,
	"./wedding-websites@1x.png": 1940,
	"./wedding-websites@2x.png": 1941,
	"./wedding_help.png": 827,
	"./wedding_help.svg": 1942,
	"./wedding_help@2x.png": 1943
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doodles nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 399
// module chunks = 49